const React = require('react');


module.exports = (props) => {
  return (
    <svg
      version="1.1" id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
      className={'dB fillCT path ' + (props.className || '')}
    >
      <g>
        <g id="XMLID_3441_">
          <g id="XMLID_3474_">
            <path id="XMLID_19578_" className="st0" d="M453.5,494.1H58.5C29.5,494.1,6,469.7,6,439.8V201.6c0-17.7,8.3-34.3,22.3-44.5
                l44.6-32.4c4.8-3.5,11.7-2.5,15.2,2.4c3.5,4.9,2.5,11.7-2.4,15.2l-44.6,32.4c-8.4,6.1-13.4,16.1-13.4,26.9v238.2
                c0,18,13.8,32.6,30.7,32.6h395.1c16.9,0,30.7-14.6,30.7-32.6V201.6c0-10.8-5-20.8-13.4-26.9l-44.2-32.1
                c-4.9-3.5-5.9-10.3-2.4-15.2c3.5-4.9,10.4-5.9,15.2-2.4l44.2,32.1c14,10.2,22.3,26.8,22.3,44.5v238.2
                C506,469.7,482.5,494.1,453.5,494.1z"/>
          </g>
          <g id="XMLID_3459_">
            <path id="XMLID_19577_" className="st0" d="M166.4,81c-3.4,0-6.7-1.5-8.8-4.5c-3.5-4.9-2.5-11.6,2.4-15.2l30.2-22
                c39.3-28.6,92.2-28.6,131.5,0l29.9,21.7c4.9,3.5,5.9,10.3,2.4,15.2c-3.5,4.9-10.3,5.9-15.2,2.4L309,56.9
                c-31.7-23.1-74.3-23.1-106,0l-30.2,22C170.8,80.3,168.6,81,166.4,81z"/>
          </g>
          <g id="XMLID_3454_">
            <path id="XMLID_19576_" className="st0" d="M256,343.7c-21.3,0-42.5-6.2-61-18.5L54.3,231.4c-5-3.3-6.3-10.1-3-15.1
                c3.4-5,10.1-6.3,15.1-3L207,307.1c29.7,19.8,68.2,19.8,97.9,0l140.7-93.8c4.9-3.3,11.7-2,15.1,3c3.3,5,2,11.7-3,15.1L317,325.2
                C298.5,337.5,277.2,343.7,256,343.7z"/>
          </g>
          <g id="XMLID_3453_">
            <path id="XMLID_19575_" className="st0" d="M429.9,244.1c-6,0-10.9-4.9-10.9-10.9V81.1H93v152.2c0,6-4.9,10.9-10.9,10.9
                c-6,0-10.9-4.9-10.9-10.9v-163c0-6,4.9-10.9,10.9-10.9h347.8c6,0,10.9,4.9,10.9,10.9v163C440.8,239.2,435.9,244.1,429.9,244.1z"
            />
          </g>
          <g id="XMLID_3447_">
            <path id="XMLID_19574_" className="st0" d="M256,233.2c-29.2,0-52-12.6-54.2-29.9c-0.8-6,3.5-11.4,9.4-12.2
                c5.8-0.7,11.4,3.4,12.2,9.4c0.4,3.2,12.3,10.9,32.7,10.9c22.1,0,32.7-8.7,32.7-10.9c0-0.1-0.4-6.8-31.7-10.7l-2.3-0.3
                c-15.9-1.9-52.9-6.5-52.9-32.5c0-18.6,23.4-32.6,54.4-32.6c29.2,0,52,12.6,54.2,29.8c0.8,6-3.5,11.4-9.4,12.2
                c-5.9,0.7-11.4-3.4-12.2-9.4c-0.4-3.2-12.3-10.8-32.6-10.8c-21.1,0-32.7,8.2-32.7,10.9c0,0.1,0.4,6.8,31.8,10.7
                c0.1,0,2.2,0.3,2.3,0.3c15.9,2,52.8,6.5,52.8,32.5C310.3,219.2,287,233.2,256,233.2z"/>
          </g>
          <g id="XMLID_3446_">
            <path id="XMLID_19573_" className="st0" d="M256,255c-6,0-10.9-4.9-10.9-10.9V113.7c0-6,4.9-10.9,10.9-10.9c6,0,10.9,4.9,10.9,10.9
                v130.4C266.9,250.1,262,255,256,255z"/>
          </g>
          <g id="XMLID_3444_">
            <path id="XMLID_19572_" className="st0" d="M343,298.4H158.2c-6,0-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9H343
                c6,0,10.9,4.9,10.9,10.9S349,298.4,343,298.4z"/>
          </g>
          <g id="XMLID_3443_">
            <path id="XMLID_19571_" className="st0" d="M386.4,124.5H343c-6,0-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9h43.5
                c6,0,10.9,4.9,10.9,10.9S392.4,124.5,386.4,124.5z"/>
          </g>
          <g id="XMLID_3442_">
            <path id="XMLID_19570_" className="st0" d="M169,255h-43.5c-6,0-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9H169c6,0,10.9,4.9,10.9,10.9
                S175.1,255,169,255z"/>
          </g>
        </g>
      </g>
    </svg>
  );
};
